export const formatCareOfDisplay = (patientDetails) => {
  if (!patientDetails) return null;
  
  const suffix = patientDetails?.metadata?.careof_suffix || 'C/O:';
  const careOfName = patientDetails?.careof_name || patientDetails?.metadata?.careof_name;
  
  if (!careOfName) return null;
  
  const result = suffix ? `${suffix} ${careOfName}` : careOfName;
  return result;
};

export const getCareOfDisplay = (patientDetails) => {
  const careOfDisplay = formatCareOfDisplay(patientDetails);
  return careOfDisplay || 'N/A';
};